/** Centralised localStorage key names — all follow anojeje_ + snake_case convention. */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'anojeje_auth_token',
  // Real, role-bearing GuestGuru JWT — obtained via the backend's OAuth
  // callback / password login, exchanged server-to-server against
  // GuestGuru's /auth/login(/trusted). Sent as Authorization: Bearer on
  // GuestGuru API calls instead of relying on the spoofable x-user-email
  // header. Distinct from AUTH_TOKEN, which is this app's own session token.
  GG_AUTH_TOKEN: 'anojeje_guestguru_auth_token',
  // The project the person is working in (a uuid). Stored under a new key in
  // the port; the pre-port key is read once and migrated (see utils/session.ts).
  PROJECT_ID: 'anojeje_project_id',
  LEGACY_WEDDING_ID: 'anojeje_wedding_id',
  LAST_LOGIN: 'anojeje_last_login',
  // '1' while the signed-in session came from the one-click demo login: that session has only the
  // planning-API token, so it is verified against the planning API instead of the app's own backend.
  DEMO_SESSION: 'anojeje_demo_session',
  PROFILE_OWNER_EMAIL: 'anojeje_profile_owner_email',
  SITE_BUILDER_RELEASES: 'anojeje_site_builder_releases',
} as const;
